const initialCreateUserRoleValue = {
	roleName: '',
	roleDescription: '',
	permissionGroupList: [],
};

export default initialCreateUserRoleValue;
